import { cn } from '@simplywallst/ui-core/next';
import { CompanyLogo } from '@/components/CompanyLogo';
import { useSummary } from '@/hooks/useCompany';
import { useTranslation } from '@/hooks/useTranslation';
import { useMetricData } from '../hooks/useMetricData';
import { Bones } from './Bones';

export const CompanyHeader = () => {
  const summary = useSummary();
  const data = useMetricData();
  const t = useTranslation();

  // data.status = 'loading';
  // summary.status = 'loading';

  return (
    <div className="@container/ch">
      <div className="grid grid-cols-[65px_auto] gap-x1_5 sm:grid-cols-[75px_auto] sm:gap-x2 lg:grid-cols-[88px_auto]">
        <div
          className={cn(
            'mt-x0_25 aspect-1 select-none rounded-lg bg-surface-2 shadow-md',
            // TODO: CompanyIcon: Convert to Tailwind to unblock removal of overrides
            '[&>*]:!h-full [&>*]:!w-full',
            summary.status === 'loading' && 'animate-pulse'
          )}
        >
          {summary.status === 'success' && (
            <CompanyLogo
              website={summary.website}
              tickerSymbol={summary.tickerSymbol}
              sizeLg={75}
              hasLogo={summary.hasLogo}
            />
          )}
        </div>
        <div className="flex flex-col gap-x0_75 ">
          <h1 className="m-0 grid gap-y-px leading-[0] text-solid">
            <span className="mt-x0_25 text-balance break-words text-lg font-medium leading-tight sm:text-xl lg:text-mega lg:leading-[1.2]">
              {summary.status === 'loading' ? (
                <Bones className="max-w-[90%]" />
              ) : (
                summary.name
              )}
            </span>
            <span className="block text-pretty text-xs font-normal leading-tight sm:text-sm">
              {summary.status === 'loading' ? (
                <Bones className="max-w-[90%]" />
              ) : (
                t('page.companyReport.header.companyTitle', {
                  uniqueSymbol: summary.uniqueSymbol,
                })
              )}
            </span>
          </h1>
          <div className="text-xs text-soft">
            {data.status === 'loading' ? (
              <Bones className="max-w-[18ch]" />
            ) : (
              <span aria-label={`Market Cap ${data.marketCapListingFormatted}`}>
                <span className="whitespace-nowrap">Market Cap </span>
                {data.marketCapListingFormatted}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
